// extracted by mini-css-extract-plugin
module.exports = {"products":"CE-z","misad":"DE-z","oosMessaging":"EE-z","topProductFrame":"FE-z","productCardOverrides":"GE-z","secondRowAds":"HE-z","microsoftAdsWrapper":"IE-z"};